export default __webpack_public_path__ + "static/media/rozbudowa2.faf23d87.svg";